<template lang="pug">
	section
		div(v-if="requestSent")
			p.mb-4
				| If the
				strong
					|  {{this.email}}
				|  email address is associated with a Savingforcollege.com account, you'll receive an email shortly with a link to reset your password.
			p.mb-5
				| Please check your inbox.
			br
			.continue-button.mt-5
				sfc-button(text="BACK TO LOGIN" :blue="true" :continue-arrow="true" @click="back()")
		div(v-if="!requestSent")
			form
				p.mb-4
					| Enter your email address to begin the reset password process.
				p.mb-5
					| Once entered, we will send a reset link to the email address you specified. If you use a mail filtering tool make sure you allow email from support@savingforcollege.com prior to submitting the request.
				div.mb-4
					label
						| Email
					div.email-container
						sfc-input-v2.text-input(v-model="email" type="text" :error="emailError" :error-message="emailErrorMessage" inputmode="email" :scroll-on-focus="true" :scroll-container="`.sfc-onboarding-mobile-v3`" name="email" @input="validateEmail")
				br
				.continue-button.mt-5
					sfc-button.mr-4(:blue="false" :back-arrow="true" @click="back()")
					sfc-button(text="RESET MY PASSWORD" :blue="true" :continue-arrow="true" @click="next()")

</template>

<style lang="stylus">
#forgot-your-password-modal
	.modal-content
		.modal-body
			padding 50px 50px 80px 50px
	.text-input
		.tb
			box-shadow: inset 0 1px 3px 0 rgba(101, 116, 134, 0.05);
			border: solid 0.5px #657486
</style>

<style lang="stylus" scoped>

	label
		font-size: body-font-size-md
	.email-container
		width: 250px
		@media (max-width: 991px)
			width: 100%
	.bordered-left
		border-left solid 0.5px #ced3e1;
	.link
		color #2486e7
	.cursor-pointer
		cursor pointer
	.close-in-word
		cursor pointer
		font-size: body-font-size
		top: -25px
		right: 0px
		position: absolute
		color: #fff
</style>

<script>

import SfcButton from '@/common/components/sfc-button'
import SfcInputV2 from '@/common/components/inputs/v2/textbox'

export default {

	props: {
	},

	components:{
		SfcButton,
		SfcInputV2
	},

	data() {
		return {
			emailError: false,
			emailErrorMessage: null,
			email: "",
			progressLength: 90,
			requestSent: false,
			validateOnChange: false
		}
	},


	methods: {

		validateEmail(){
			if(this.validateOnChange){
				this.emailError = false
				this.emailErrorMessage = ""
				const emailRegex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

				if (!emailRegex.test(this.email)) {
					this.emailError = true
					this.emailErrorMessage = "Please enter a valid email"
					return false
				}

			}

			return true
		},

		back(){
			this.requestSent = false
			this.email = null
			this.$emit('next', 0, "Log In to your account", "sfc-log-in-to-your-account")
		},

		async resetPwd(){
			if(!this.validateEmail())	return

			const url = `${this.$store.state.config.sfcHost}/reset_password/index.php`
			const params = {
				email: this.email,
				mode: "send_key",
				via: "ajax",
				from_app: "spa_nuxt"
			}
			const response = await this.$httpService.post(url, params)
			if (!response.success){
				this.emailErrorMessage = response.error
			}else{
				this.showSuccess = true
			}
		},
		next(){
			this.validateOnChange = true
			if(!this.validateEmail()){
				return
			}
			this.resetPwd()
			this.requestSent = true
		},

	}

}
</script>
